import React, { useState } from 'react';
import { GoArrowRight } from "react-icons/go";
import { Link } from 'react-router-dom';
import './BlogCard.css';
import collegePlaceholder from '../../assets/images/ftrdClgImgPlaceholder.png';
import { generatePublicUrlLocal } from '../../config';

const BlogCard = ({ blog }) => {
  // console.log(blog)
  const { id, title, readTime, excerpt, author, date, image, category } = blog;
  const [imgError, setImgError] = useState(false);

  const handleImageError = () => {
    setImgError(true);
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  return (
    <div className="blog-card">
      <div className="blog-card-img-container">
        <img 
          src={ imgError || !image  ?  collegePlaceholder  :  generatePublicUrlLocal(image) }
          alt={title} 
          className="blog-card-img"
        />
      </div>
      <div className="blog-card-content">
        <h3 className="blog-card-title">{title}</h3>
        <p className="blog-card-meta">
          {readTime} • {formatDate(date)}
        </p>
        <p className="blog-card-description">
          {excerpt && excerpt.length > 100 ? excerpt.substring(0, 100) + '...' : excerpt}
        </p>
        <Link to={`/blogs/${id}`} className="blog-card-link">
          Read full article <GoArrowRight className="blog-card-icon" />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
